import React, { ReactNode } from 'react';
import { Box, Split } from '@dropbox/dig-foundations';
import { WhiteLabelThemeProvider } from 'signer-app/white-labeling/theme-provider';
import styles from 'signer-app/signer-experience/signer-toolbar/signer-toolbar.module.css';
import ToolbarZoomControls from 'signer-app/parts/toolbar-zoom-controls';
import { ContinueButton } from '../action-buttons/continue-button';
import { SignStepToolbarLayout } from './sign-step-toolbar-layout';
import { useFeatureFlag } from 'signer-app/context/feature-flags';
import { AccessibleDocumentToggle } from 'signer-app/signer-signature-document/accessible-document-toggle';
import { useSignerContext } from '../signer-experience';

export function DrawerToolbarV2({ toolbarMenu }: { toolbarMenu: ReactNode }) {
  const { hideFormViewToggle } = useSignerContext();

  return (
    <SignStepToolbarLayout>
      <Split gap="Micro Small" alignY="center">
        <Split.Item>{toolbarMenu}</Split.Item>
        <Split.Item>
          <ToolbarZoomControls variant="outline" />
        </Split.Item>
        {!hideFormViewToggle && (
          <Split.Item>
            <AccessibleDocumentToggle />
          </Split.Item>
        )}
      </Split>
      <Split
        gap={{
          small: 'Micro Large',
          xsmall: 'Micro Small',
        }}
        alignY="center"
      >
        <Split.Item>
          <ContinueButton />
        </Split.Item>
      </Split>
    </SignStepToolbarLayout>
  );
}

export function DrawerToolbar({
  toolbarMenu,
  mobileToggle,
}: {
  toolbarMenu: ReactNode;
  mobileToggle: ReactNode;
}) {
  const formViewUiImprovements = useFeatureFlag(
    'sign_core_2026_07_03_form_view_ui_improvements',
  );

  if (formViewUiImprovements) {
    return <DrawerToolbarV2 toolbarMenu={toolbarMenu} />;
  }

  return (
    <WhiteLabelThemeProvider mode="bright">
      <Box
        paddingX="Micro Small"
        paddingY={'Micro Small'}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        backgroundColor="Background Subtle"
        className={styles.drawerToolbar}
        columnGap="Micro Small"
      >
        {toolbarMenu}
        {mobileToggle}

        <Box marginLeft={'auto'}></Box>

        <Split gap="Micro Large" alignY="center">
          <Split.Item>
            <ToolbarZoomControls />
          </Split.Item>
          <Split.Item>
            <ContinueButton />
          </Split.Item>
        </Split>
      </Box>
    </WhiteLabelThemeProvider>
  );
}
